module.exports = __webpack_public_path__ + "img/bed-pulse.40d12e11.svg";